/*
 |--------------------------------------------------------------------------
 |   Labstack
 |--------------------------------------------------------------------------
 */

import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import Bugsnag from '@bugsnag/js'
import $ from 'jquery'
import bootstrap from 'bootstrap-sass'
import flipclock from 'flipclock/compiled/flipclock'
import _ from 'lodash'
import axios from 'axios'
import localStore from 'store'
import queryString from 'query-string'
import * as d3 from 'd3'
import Vue from 'vue'
import store from './vuex/store'
import VueMoment from 'vue-moment'
import qq from 'fine-uploader'
import App from './components/app.vue'
import './components.js'

// Bugsnag
Bugsnag.start('835e660d83cfa14b896a4a15050dd6e0')

// Devtools enabled
Vue.config.devtools = (process.env.NODE_ENV !== 'production')

// Silence logs and warnings
Vue.config.silent = (process.env.NODE_ENV == 'production')

window._ = _
window.Alpine = Alpine
window.axios = axios
window.Bugsnag = Bugsnag
window.localStore = localStore
window.queryString = queryString
window.Vue = Vue
window.qq = qq
window.$ = window.jQuery = $

axios.defaults.headers.common = {
    'Accept': 'application/vnd.api+json; version=1; charset=utf-8',
    'X-CSRF-TOKEN': window.Labstack.csrf_token,
    'X-Requested-With': 'XMLHttpRequest',
};

// install vue-moment filter
Vue.use(VueMoment)

Alpine.plugin(focus)

// If using vue.js on the page, then activate root component.
if ($('#vue-labstack').length > 0) {
  new Vue({
    store,
    ...App
  })
}

Alpine.start()

$(function() {
  // Prevent double clicks on links (use click-prevent class)
  $('a.click-prevent').click(function(event) {
    if ($(this).data('clicked')) {
      event.preventDefault()
      return false
    }
    $(this).data('clicked', true)
  });

  // Prevent double clicks on forms
  $('form').submit(function(e) {
    $('input[type="submit"], button[type="submit"]').each(
      function(e) {
        $(this).disabled = true
        $(this).html('<span class="relative z-10 flex-1">Please wait...</span>')
      }
    )
  });

  // Load images from markdown into a modal when they are clicked
  $('.markdown-output img').click(function() {
     $('#image-preview').attr('src', $(this).attr('src'))
     $('#image-modal').modal('show')
  })
})
